import { render, staticRenderFns } from "./LoginWarning.vue?vue&type=template&id=9b973d22&scoped=true"
import script from "./LoginWarning.vue?vue&type=script&lang=js"
export * from "./LoginWarning.vue?vue&type=script&lang=js"
import style0 from "./LoginWarning.vue?vue&type=style&index=0&id=9b973d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b973d22",
  null
  
)

export default component.exports